import SignupMatchSubject from "../views/match/SignupMatchSubject.vue";
import MatchSubjectScore from "../views/match/MatchSubjectScore.vue";
import MatchSubjectsApplyInfo from "../views/match/MatchSubjectsApplyInfo.vue";

const matchRoutes = [
  {
    path: "/matchSubjectsApplyInfo",
    name: "matchSubjectsApplyInfo",
    component: MatchSubjectsApplyInfo,
  },
  {
    path: "/signupMatchSubject",
    name: "signupMatchSubject",
    component: SignupMatchSubject,
  },
  {
    path: "/matchsubjectscore",
    name: "matchsubjectscore",
    component: MatchSubjectScore,
  },
];

export default matchRoutes;
